<template>
    <v-layout class="ck-editor">
        <div v-if="canUploadImage" class="ck-editor__image-upload">
            <photo-uploader
                :is-type-icon="true"
                :upload-callback="updateImageUpload"
                :uploader-id="`${editorId}-image-upload`"
            >
            </photo-uploader>
        </div>
        <textarea :id="editorId" :data-qe-id="editorId"></textarea>
    </v-layout>
</template>

<script>
import { ckEditorType } from '@/plugins/CkEditor/ckEditorTypes.config';
import { inputFilterForImageFile } from '@/common/utils/fileUploader';
import FileUpload from 'vue-upload-component';
import PhotoUploader from '../PhotoUploader/PhotoUploader';

import CKEditorMixin from '../../mixins/CKEditorMixin';

export default {
    name: 'CkEditor',
    mixins: [CKEditorMixin],
    components: {
        PhotoUploader,
        FileUpload,
    },
    props: {
        value: {
            type: String,
        },
        editorId: {
            type: String,
            required: true,
            default: 'ypoEditor',
        },
        editorType: {
            type: String,
            default: ckEditorType.FULL,
        },
        height: {
            type: String,
            default: '100%',
        },
        width: {
            type: String,
            default: '100%',
        },
        language: {
            type: String,
            default: 'en',
        },
        extraPlugins: {
            type: String,
            default: '',
        },
        updateImageUpload: {
            type: Function,
            default: () => {},
        },
        inputFilterForImage: {
            type: Function,
            default: () => {},
        },
        canUploadImage: {
            type: Boolean,
            default: false,
        },
        autoFocus: {
          type: Boolean,
          default: true,
        },
    },
    data() {
        return {
            files: [],
        };
    },

    methods: {
        inputFilterForImageFile,
    },
    /* eslint-enable no-undef */
};
</script>

<style lang="scss">
@import '../../common/styles/_colors.scss';

.ck-editor {
    position: relative;

    .cke {
        border: none;
        position: relative;
    }

    .cke_top {
        background-color: $white;
        border-top: 1px solid $ypo-medium-gray;
        border-bottom: 1px solid $ypo-medium-gray;
    }

    .cke_bottom {
        background-color: $white;
        border-top: none;
        border-bottom: 2px solid $ypo-medium-gray;
    }

    a {
        &.cke_button {
            height: 100%;
            cursor: pointer;
        }
    }

    .cke_path {
        display: none;
    }

    &__image-upload {
        position: absolute;
        cursor: pointer;
        z-index: 1000;
        right: 0;

        .photo-uploader__btn {
            background: none;
            border: none;
        }

        label {
            cursor: pointer;
        }
    }
}
</style>
